(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lorca-recent-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lorca-featured')) {
  customElements.define('lorca-featured', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.lorca-featured__track');
      const candidates = [...track.children].map(el => el.tagName === 'TEMPLATE' ? el.content.firstElementChild : el);
      const unique = [...new Map(candidates.map(el => [el.dataset.product, el])).values()];
      let seed = Math.floor(Date.now() / 172800000) >>> 0;
      const random = () => { seed += 0x6D2B79F5; let x = seed; x = Math.imul(x ^ x >>> 15, x | 1); x ^= x + Math.imul(x ^ x >>> 7, x | 61); return ((x ^ x >>> 14) >>> 0) / 4294967296; };
      const shuffle = list => { for (let i = list.length - 1; i > 0; i--) { const j = Math.floor(random() * (i + 1)); [list[i], list[j]] = [list[j], list[i]]; } return list; };
      const groups = new Map();
      unique.sort((a,b) => a.dataset.product.localeCompare(b.dataset.product)).forEach(el => { const key = el.dataset.vendor; if (!groups.has(key)) groups.set(key, []); groups.get(key).push(el); });
      const buckets = shuffle([...groups.values()].map(shuffle));
      const selected = [];
      while (selected.length < 8 && buckets.some(group => group.length)) {
        for (const group of buckets) { if (group.length && selected.length < 8) selected.push(group.shift().cloneNode(true)); }
      }
      track.replaceChildren(...selected);
      this.dataset.selectionWindow = String(Math.floor(Date.now() / 172800000));
      const controls = this.querySelector('.lorca-featured__controls');
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      const update = () => { prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; controls.hidden = track.scrollWidth <= track.clientWidth + 2; };
      const move = direction => { const first = track.firstElementChild; if (!first) return; const gap = parseFloat(getComputedStyle(track).columnGap) || 0; const step = first.getBoundingClientRect().width + gap; const count = Math.max(1, Math.floor((track.clientWidth + gap) / step)); track.scrollBy({left: direction * step * count, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}); };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('keydown', event => { if (event.target !== track) return; if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); } });
      track.addEventListener('scroll', update, {passive:true});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
